<template>
  <div class="scrrolMidTable position-relative">
    <alert-notification v-if="notification_msg != ''" />
    <div class="mid_scroll_content scrollbar spPgae mt-0">
      <loader v-if="pageLoader"></loader>
      <section class="tab-content border-0 max-1440 incgMob" v-if="!showTopic">
        <div class="main_inner_section services_request">
          <div
            class="support_search row align-items-center justify-content-center mb-3 pt-2 mb-md-5"
          >
            <div class="col-12 col-lg-6 section_title m-0 text-center">
              <h5 class="support_title my-4">How Can We Help You Today?</h5>
              <!-- <p>Please write to us with your queries. Our team will get in touch with you</p> -->
              <div class="supportTanb_btn d-flex justify-content-center align-items-center">
                <a href="javascript:void(0)" class="links cap_btn active"
                  >Support</a>
                <a href="javascript:void(0)" class="links" @click="reqNewTicket()">Request New Ticket</a
                >
              </div>
            </div>
          </div>
          <div class="row justify-content-center mx-0">
            <div class="col-12 maxCustom">
              <div
                class="field-wrapper interSearch position-relative searchReasons"
                :class="[
                  {
                    active:
                      allowSearch && searchReasons && allReasons.length > 0,
                  },
                ]"
              >
                <div class="form-group mb-0">
                  <input
                    type="text"
                    class="form-control lightgrayBG"
                    id="myInput"
                    placeholder="Search Here"
                    v-model="searchReasons"
                    @focus="allowSearch = true"
                  /><!-- @blur="allowSearch = false" -->
                  <a href="javascript:void(0)" class="searchIcon"
                    ><feather type="search"></feather
                  ></a>
                </div>
                <ul
                  class="search-listing text-left w-100 box-shadow scrollbar"
                  v-if="allowSearch && searchReasons && allReasons.length > 0"
                >
                  <li
                    class="hvr-grow-shadow"
                    v-for="(item, index) in allReasons"
                  >
                    <a href="javascript:void(0)" @click="getTopic(item)">
                      <feather type="search" />
                      {{ item.title }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Top Questions -->
            <div class="col-12 col-md-6 border-right">
              <div class="verifyAcc">
                <h5 class="medium mb-4">Top Questions</h5>
                <ul class="topQuestion">
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="
                        callToken(
                          '2',
                          '21',
                          'Account Verification',
                          '1',
                          '1',
                          'Profile',
                          '1',
                          false,
                          '',
                          '',
                          '',
                          true,
                          1
                        )
                      "
                    >
                      What documents are needed to verify my account?</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="
                        callToken(
                          '3',
                          '88',
                          'Change Phone Number',
                          '0',
                          '1',
                          'Profile',
                          '1',
                          false,
                          '',
                          '',
                          '',
                          true,
                          1
                        )
                      "
                    >
                      Where can I change my phone number?</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="
                        callToken(
                          '2',
                          '26',
                          'Disable 2FA',
                          '1',
                          '1',
                          'Profile',
                          '1',
                          false,
                          '',
                          '',
                          '',
                          true,
                          1
                        )
                      "
                    >
                      How do I disable the two-factor authentication?
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="
                        callToken(
                          '2',
                          '65',
                          'How to Receive Digital Currencies into your Wallet',
                          '1',
                          '5',
                          'Deposits',
                          '5',
                          false,
                          '',
                          '',
                          '',
                          true,
                          1
                        )
                      "
                    >
                      How to Receive Digital Currencies into your Wallet?</a
                    >
                  </li>
                </ul>
                <a
                  href="javascript:void(0)"
                  class="cap_btn lg mt-4"
                  @click="showTopic = true"
                  >Browse Help Topics
                </a>
              </div>
            </div>
            <!-- open/closed ticket -->
            <div class="col-12 col-md-6">
              <div class="accessSystem">
                <div class="d-flex align-items-center justify-content-between mobSpace">
                  <h5 class="medium mb-md-4">Tickets</h5>
                  <!-- <div
                    class="form-group position-relative includeIco searchTable mb-0"
                  >
                    <input
                      type="text"
                      placeholder="Search all Cryptos"
                      name="legal_name"
                      class="form-control small"
                    />
                    <span class="searchIco"
                      ><feather type="search"></feather>
                    </span>
                  </div> -->
                </div>
                <ul class="d-flex align-items-center tabTickets my-md-4">
                  <li>
                    <a
                      class="nav-link medium"
                      @click.prevent="ticketsTab = '0'"
                      :class="ticketsTab == '0' ? 'active' : ''"
                      href="javascript:void(0)"
                      >Open</a
                    >
                  </li>
                  <li>
                    <a
                      class="nav-link medium"
                      @click.prevent="ticketsTab = '3'"
                      :class="ticketsTab == '3' ? 'active' : ''"
                      href="javascript:void(0)"
                      >Closed</a
                    >
                  </li>
                </ul>
                <ticket-list v-if="ticketsTab == '0'" />
                <ticket-list v-if="ticketsTab == '3'" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="tab-content border-0 max-1440 incgMob" v-else>
        <!-- showDiv = {{showDiv}}
              <br>title = {{title}}
              <br>title_text = {{title_text}}
              <br>info_req = {{info_req}}
              <br>reason = {{reason}}
              <br>reason_text = {{reason_text}}
              <br>loadServiceRequest = {{loadServiceRequest}}
              <br>serviceRequest = {{serviceRequest}}
              <br>ticketRequestFrom = {{ticketRequestFrom}}
              <br>inList_custom_id = {{inList_custom_id}}
              <br>method_id = {{method_id}}
              <br>showTopic = {{showTopic}} -->
        <div class="d-flex align-items-center justify-content-between mb-md-5 border-bottom pb-1"
          v-if="showDiv == '1'"
        >
          <div class="openTicket">
            <h3>Opened Support Tickets</h3>
            <p>
              Capital Wallet always here to help you with your unsettled issues
            </p>
          </div>
          <a
            href="javascript:void(0)"
            class="backButton d-flex align-items-center"
            @click="allBack()"
            ><feather class="mr-1" size="17px" type="arrow-left"></feather>
            Back</a
          >
        </div>
        <div class="d-flex align-items-center justify-content-end mb-md-5 border-bottom pb-3"
          v-if="showDiv == '2' || showDiv == '3'"
        >
          <a
            href="javascript:void(0)"
            class="backButton d-flex align-items-center"
            @click="allBack()"
            ><feather class="mr-1" size="17px" type="arrow-left"></feather>
            Back</a
          >
        </div>
        <div class="text-center">
          <!--   -->
          <h5 class="support_title my-4" v-if="showDiv == '1'">
            How Can We Help You Today?
          </h5>
          <div class="col-12 maxCustom">
            <div
              class="form-group field-wrapper interSearch"
              v-if="showDiv == '1'"
            >
              <input
                type="text"
                class="form-control lightgrayBG"
                id="myInput"
                name=""
                placeholder="Search Here"
                v-on:keyup="keymonitor"
              />
              <a href="javascript:void(0)" class="searchIcon"
                ><feather type="search"></feather
              ></a>
            </div>
            <div class="whiteBG right-chatBlock w-100" v-if="serviceRequest">
              <div id="major_service_sec" class="outer_major_sersec">
                <ul
                  class="inner_dropdown request_lisec mb-5"
                  id="myUL"
                  v-if="ticketReasonList != ''"
                >
                  <li
                    v-for="list in ticketData[-1]"
                    v-if="
                      parseInt(ticketReasonList[list].status) == 1 &&
                      parseInt(ticketReasonList[list].tickets) == 1 &&
                      list != '16'
                    "
                    class="effect-bubba"
                  >
                    <a
                      href="javascript:void(0)"
                      v-on:click="enableRequestElement(list)"
                    >
                      <div class="icon listWith">
                        <img
                          :src="
                            '../../../../static/website/images/' +
                            iconFile[list].icon
                          "
                          alt="Icon"
                        />
                      </div>
                      <figcaption>
                        <h6>{{ iconFile[list].lang }}</h6>
                      </figcaption>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="request_changesec" v-else>
              <div class="row justify-content-center align-items-center">
                <div class="col-12 p-0">
                  <div class="compose_mailsec">
                    <app-profile
                      :ticketFilter="ticketReasonList[loadServiceRequest]"
                      :ticketRequest="ticketRequestFrom"
                      :accountIdFrom="account_id"
                    ></app-profile>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { supportMixins } from "@/plugins/support";
import profileRequest from "./services/profile_request";
import ticketList from "./ticket-list";
export default {
  name: "SERVICES",
  mixins: [supportMixins],
  data() {
    return {
      pageLoader: false,
      pageTitle: this.$options.name,
      notification_msg: "",
      notification_type: "",
      ticketsTab: "0",
      searchReasons: "",
      allowSearch: false,
      iconFile: {
        1: { icon: "sr_profile.svg", title: "Profile", lang: "Profile" },
        2: {
          icon: "sr_tradingaccount.svg",
          title: "Exchange",
          lang: "Exchange",
        },
        3: { icon: "otherTicket.svg", title: "PAMM Requests", lang: "" },
        4: { icon: "otherTicket.svg", title: "IB Requests", lang: "" },
        5: { icon: "sr_deposit.svg", title: "Deposits", lang: "Deposits" },
        6: {
          icon: "sr_withdrawals.svg",
          title: "Withdrawals",
          lang: "Withdrawals",
        },
        7: { icon: "sr_bonus.svg", title: "Bonus", lang: "" },
        8: { icon: "sr_vps.svg", title: "VPS", lang: "VPS" },
        9: { icon: "sr_reimbursement.svg", title: "Reimbursement", lang: "" },
        10: {
          icon: "sr_complaints.svg",
          title: "Complaints",
          lang: "Complaints",
        },
        11: { icon: "sr_compliance.svg", title: "Compliance", lang: "" },
        12: { icon: "sr_feedback.svg", title: "Feedback", lang: "Feedback" },
        13: { icon: "sr_others.svg", title: "Others", lang: "Others" },
        16: {
          icon: "sr_addpayment.svg",
          title: "Add Payment Method",
          lang: "Add payment method",
        },
        91: {
          icon: "otherTicket.svg",
          title: "Registeration Documents",
          lang: "",
        },
        92: { icon: "otherTicket.svg", title: "Skip Documents", lang: "" },
        94: { icon: "otherTicket.svg", title: "Become A Pro", lang: "" },
      },
      showTopic: false /* show all topic section */,
      loadServiceRequest: "" /* seleccted topic number */,
      serviceRequest: true /* false if only topic shown */,
      ticketRequestFrom: "" /*come request from deposit---- or another page*/,
      account_id: "",
      method_id: "",
      inList_custom_id: "",

      showDiv:
        "1" /* (1:-only topic),(2:-topic with discription),(1:-only form) */,
      reason: "" /* expanded topic number */,
      reason_text: "" /* expanded topic name */,
      title: "0" /* expanded sub-topic number */,
      title_text: "" /* expanded sub-topic name */,
      info_req: "" /* if any form Open */,
      fromStart: 0 /* 0: simple back, 1: main home, 2: showTopic=true */,
    };
  },
  components: {
    appProfile: profileRequest,
    ticketList,
  },
  computed: {
    allReasons() {
      let allList = [];
      for (const index in this.ticketData[-1]) {
        let list = this.ticketData[-1][index];
        if (
          parseInt(
            this.ticketReasonList && this.ticketReasonList[list].status
          ) == 1 &&
          parseInt(this.ticketReasonList[list].tickets) == 1 &&
          list != "16" &&
          this.ticketReasonList[list].categories
        ) {
          allList = allList.concat(
            Object.values(this.ticketReasonList[list].categories)
          );
        }
      }
      return allList.filter(
        (val) =>
          val.title.toLowerCase().includes(this.searchReasons.toLowerCase()) ||
          this.searchReasons.toLowerCase().includes(val.title.toLowerCase())
      );
    },
  },
  methods: {
    getTopic(item) {
      // console.log(item)
      this.allowSearch = false;
      let showDiv = parseInt(item.infomration_req) ? "2" : "3",
        title = item.id,
        title_text = item.title,
        info_req = item.infomration_req,
        reason = item.parent_id,
        reason_text = this.ticketReasonList[item.parent_id].title,
        loadServiceRequest = item.parent_id,
        serviceRequest = false;
      this.callToken(
        showDiv,
        title,
        title_text,
        info_req,
        reason,
        reason_text,
        loadServiceRequest,
        false,
        "",
        "",
        "",
        true,
        1
      );
    },
    reqNewTicket() {
      this.showDiv = "3";
      this.title = "0";
      this.reason = "13";
      this.reason_text = "Others";
      this.loadServiceRequest = "13";
      this.serviceRequest = false;
      this.showTopic = true;
    },
    callToken(
      showDiv,
      title,
      title_text,
      info_req,
      reason,
      reason_text,
      loadServiceRequest,
      serviceRequest,
      ticketRequestFrom,
      inList_custom_id,
      method_id,
      showTopic,
      from
    ) {
      this.showDiv = showDiv;
      this.title = title;
      this.title_text = title_text;
      this.info_req = info_req;
      this.reason = reason;
      this.reason_text = reason_text;
      this.loadServiceRequest = loadServiceRequest;
      this.serviceRequest = serviceRequest;
      this.ticketRequestFrom = ticketRequestFrom;
      this.inList_custom_id = inList_custom_id;
      this.method_id = method_id;
      this.showTopic = showTopic;
      this.fromStart = from;
    },
    allBack() {
      if (this.loadServiceRequest != "") {
        if (this.fromStart) {
          this.showDiv = 1;
          this.title = 0;
          this.title_text = "";
          this.info_req = "";
          this.reason = "";
          this.reason_text = "";
          this.loadServiceRequest = "";
          this.serviceRequest = true;
          this.ticketRequestFrom = "";
          this.inList_custom_id = "";
          this.method_id = "";
          if ((this.fromStart = 1)) {
            this.showTopic = false;
          } else {
            this.showTopic = true;
          }
          this.fromStart = 0;
          return;
        }
        if (this.showDiv == "2" || this.showDiv == "3") {
            this.showDiv = "1";
            this.title = "0";
            this.title_text = "";
            this.info_req = "";
            if (
              parseInt(this.reason) == 13 &&
              parseInt(this.loadServiceRequest) == 13
            ) {
              this.reason = "";
              this.reason_text = "";
              this.loadServiceRequest = "";
              this.serviceRequest = true;
            }
        } else {
          this.reason = "";
          this.reason_text = "";
          this.loadServiceRequest = "";
          this.serviceRequest = true;
        }
        this.ticketRequestFrom = "";
        this.inList_custom_id = "";
        this.method_id = "";
        // this.showDiv = '1'
      } else {
        this.showTopic = false;
      }
    },
    keymonitor() {
      var input, filter, ul, li, a, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      ul = document.getElementById("myUL");
      li = ul.getElementsByTagName("li");

      // Loop through all list items, and hide those who don't match the search query
      for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];

        txtValue = a.textContent || a.innerText;

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = "";
        } else {
          li[i].style.display = "none";
        }
      }
    },
    enableRequestElement(elementName) {
      this.loadServiceRequest = elementName;
      if (
        !parseInt(
          this.ticketReasonList[this.loadServiceRequest].infomration_req
        ) ||
        (parseInt(this.loadServiceRequest) == 16 && this.method_id != "") ||
        (parseInt(this.loadServiceRequest) == 5 && this.method_id != "") ||
        (parseInt(this.loadServiceRequest) == 1 && this.method_id != "")
      ) {
        this.showDiv = "3";
        if (parseInt(this.loadServiceRequest) == 16) {
          this.chooseRequestType(
            this.inList_custom_id,
            this.ticketReasonList[this.loadServiceRequest]
          );
        } else if (parseInt(this.loadServiceRequest) == 5) {
          this.chooseRequestType(
            this.inList_custom_id,
            this.ticketReasonList[this.loadServiceRequest]
          );
        } else if (parseInt(this.loadServiceRequest) == 1) {
          this.chooseRequestType(
            this.inList_custom_id,
            this.ticketReasonList[this.loadServiceRequest]
          );
        } else {
          this.chooseRequestType(
            "",
            this.ticketReasonList[this.loadServiceRequest]
          );
        }
      } else {
        this.showDiv = "1";
      }
      this.serviceRequest = false;
    },
    chooseRequestType(getInlistId, getOutListData) {
      this.reason = getOutListData.id;
      this.reason_text = getOutListData.title;
      this.title = "0";
      this.title_text = "";
      if (getInlistId != "" && getInlistId != null) {
        let count = 0;
        for (var key in this.ticketReasonList[this.loadServiceRequest]
          .categories) {
          count++;
          if (key == getInlistId) {
            this.title = key;
            this.title_text =
              this.ticketReasonList[this.loadServiceRequest].categories[
                key
              ].title;
            this.info_req =
              this.ticketReasonList[this.loadServiceRequest].categories[
                key
              ].infomration_req;
            // console.log(
            //   "=========================================================>",
            //   parseInt(this.info_req),
            //   this.info_req,
            //   this.ticketReasonList
            // );
            // console.log(this.loadServiceRequest);
            // console.log(this.ticketReasonList[this.loadServiceRequest]);
            // console.log(
            //   this.ticketReasonList[this.loadServiceRequest].categories[key]
            // );
            // console.log(
            //   this.ticketReasonList[this.loadServiceRequest].categories[key]
            //     .infomration_req
            // );
          }
          if (
            count ==
            Object.keys(
              this.ticketReasonList[this.loadServiceRequest].categories
            ).length
          ) {
            if (!parseInt(this.info_req)) {
              this.showDiv = "3";
            } else {
              this.showDiv = "2";
            }
          }
        }
      } else {
        this.showDiv = "3";
      }
    },
  },
  mounted() {
    const _that = this;
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".searchReasons").length) {
        _that.allowSearch = false;
      }
    });
  },
  created() {
    this.pageName("Support");
    if (this.$route.params.ticketData) {
      this.showTopic = true;
      // this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
      if (parseInt(this.$route.params.ticketData) == 16) {
        this.method_id = this.$route.params.method_id;
        if (parseInt(this.method_id) == 1) {
          this.inList_custom_id = 93;
        }
        this.enableRequestElement(16);
      } else if (parseInt(this.$route.params.ticketData) == 5) {
        this.ticketRequestFrom = this.$route.params.page;
        this.method_id = this.$route.params.method_id;
        if (parseInt(this.method_id) == 69) {
          this.inList_custom_id = 69;
        }
        this.enableRequestElement(5);
      } else if (parseInt(this.$route.params.ticketData) == 1) {
        this.ticketRequestFrom = this.$route.params.page;
        this.method_id = this.$route.params.method_id;
        if (parseInt(this.method_id) == 88) {
          this.inList_custom_id = 88;
        }
        this.enableRequestElement(1);
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/supports/help-centre.vue